<template>
  <v-card
    height="24rem"
    color="background"
    class="d-flex align-center justify-center flex-column text-center"
  >
    <v-card-item>
      <v-row>
        <v-img
          src="@/shared/assets/terminalOnly.png"
          max-height="150px"
          min-height="75px"
          class="mb-5"
        />
      </v-row>
      <v-row class="mx-4 d-flex justify-center">
        <v-card-text class="text-grey-darken-1 text-body-2">
          {{ $t("page.dashboard.addATerminal") }}
        </v-card-text>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-btn
          color="primary"
          class="my-5"
          prepend-icon="mdi-star-plus-outline"
          @click="dialog = true"
        >
          {{ $t("common.action.addFavorite") }}
        </v-btn>
      </v-row>
    </v-card-item>
  </v-card>
  <add-favorite-terminal-dialog
    v-model="dialog"
    @close="dialog = false"
    @action="dialog = false"
    @added="handleFavReadersUpdated()"
  />
</template>

<script lang="ts" setup>
import AddFavoriteTerminalDialog from "@/dashboard/components/dashboard/AddFavoriteTerminalDialog.vue";
import { ref } from "vue";
import { Emit } from "@/shared/enums/emit.enum";

const emit = defineEmits([Emit.UPDATED]);

const dialog = ref(false);

const handleFavReadersUpdated = async () => {
  emit(Emit.UPDATED);
};
</script>
